import { IconButton } from '@chakra-ui/react'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Avatar from 'components/MainApp/Profile/Avatar'
import NameButton from 'components/MainApp/Profile/nameButton'
import { formatDistanceToNowStrict } from 'date-fns'
import { useAuth } from 'hooks/auth'
import { useDeleteComment } from 'hooks/comments'
import { useUser } from 'hooks/users'
import React from 'react'

import 'stylesheets/MainAppStyles/Comment.css'

const Comment = ({ comment }) => {
    const { text, date, uid, id } = comment
    const { user, isLoading: userLoading } = useUser(uid)
    const { deleteComment, isLoading: deleteLoading } = useDeleteComment(id)
    const { user: authUser, isLoading: authLoading } = useAuth()

    if (userLoading) return "Loading..."

    return (
        <div className='comment-el'>
            <Avatar user={user} />
            <div className='comment-side'>
                <div className='comment-header'>
                    <NameButton user={user} />
                    <p>@{user.username}</p>
                    <p>· {formatDistanceToNowStrict(date, false)} ago</p>
                    {
                        !authLoading && authUser.id === uid && (
                            <IconButton onClick={deleteComment} isLoading={deleteLoading} color="#" minW="25" h="25" className='trash-button' icon={<FontAwesomeIcon icon={faTrashCan} />} />
                        )
                    }
                </div>
                <p className='comment-text'>{text}</p>

            </div>
        </div>
    )
}

export default Comment